/* eslint-disable @typescript-eslint/naming-convention */
import { WebFamEvent } from './event.model';
import { WebFamSource, WebFamCitation } from './source.model';
import { WebFamPlace } from './place.model';
import { WebFamFamily } from './family.model';

export class SurnameList {
    surname: string;
    count: number;
    constructor(surname: string, count: number) {
        this.surname = surname;
        this.count = count;
    }
}

export class FileList {
    file_id?: string;
    def?: boolean;
    /** Zaznaczenie osoby na zdjęciu (ułamki kadru 0..1), gdy ktoś je zrobił. */
    region_x?: number;
    region_y?: number;
    region_w?: number;
    region_h?: number;
}

/**
 * Zdjęcie na awatar: profilowe, a gdy go nie ma - takie, na którym ktoś
 * oznaczył tę osobę (pokazujemy sam zaznaczony fragment). Nic więcej:
 * pierwsze zdjęcie z brzegu bywa zdjęciem domu albo dokumentu, więc zamiast
 * niego lepszy jest herb albo sylwetka.
 */
export function avatarFile(files?: FileList[]): FileList | undefined {
    if (!files || !files.length) {
        return undefined;
    }
    return files.find((file) => file.def === true)
        || files.find((file) => !!file.region_w && !!file.region_h);
}

/**
 * Parametry wycinka doklejane do adresu miniatury - backend przycina wtedy
 * oryginał do zaznaczenia, zamiast pokazywać całe zdjęcie grupowe.
 */
export function avatarRegionQuery(file?: FileList): string {
    if (!file || !file.region_w || !file.region_h) {
        return '';
    }
    return '?x=' + (file.region_x ?? 0) + '&y=' + (file.region_y ?? 0)
        + '&w=' + file.region_w + '&h=' + file.region_h;
}

export class WebFamChild {
    child_id!: string;
    sort?: number;
    child_type?: string;
    lookup?: string;
    person?: WebFamPerson;
}

export class WebFamPersonName {
    surname_type?: string;
    surname_prefix?: string;
    surname?: string;
    surname_suffix?: string;
    language?: string;
    isdefault?: boolean;
    name_prefix?: string;
    name?: string;
}

export class WebFamTreeViewRelationship {
    id!: string;
    husband_id!: string;
    wife_id!: string;
}

export class WebFamTreeViewChildren {
    id!: string;
    child_id!: string;
}
export class WebFamTreeView {
    id!: string;
    sex?: string;
    language!: string;
    languages?: string[];
    alive?: boolean;
    tree_id!: string;
    textid!: string;
    files?: FileList[];
    events?: WebFamEvent[];
    names?: WebFamPersonName[];
    parents_family?: string;
    relationship?: WebFamTreeViewRelationship[];
    relationship_events?: WebFamEvent[];
    relationship_children?: WebFamTreeViewChildren[];
}

export class WebFamPerson {
    id!: string;
    textid!: string;
    alive?: boolean;
    language!: string;
    sex?: string;
    tree_id!: string;
    names?: WebFamPersonName[];
    languages?: string[];
    source?: string[];
    citation?: string[];
    events?: WebFamEvent[];
    parents_family?: WebFamFamily[];
    parents?: WebFamPerson[];
    parents_events?: WebFamEvent[];
    relationship?: WebFamFamily[];
    relationship_persons?: WebFamPerson[];
    relationship_events?: WebFamEvent[];
    relationship_children?: WebFamPerson[];
    sources?: WebFamSource[];
    files?: FileList[];
    citations?: WebFamCitation[];
    relIndex?: string;
    route?: WebFamRoute[];
}

export class WebFamRoute {
    seq!: number;
    user_id!: string;
}

export class PersonSearchResult {
    personList?: WebFamPerson[];
    placeList?: WebFamPlace[];
}

export class RelationPathStep {
    seq!: number;
    person_id!: string;
    /** Krok od poprzedniej osoby na ścieżce; brak w pierwszym kroku. */
    edge?: 'up' | 'down' | 'spouse';
    family_id?: string;
}

export class RelationPathFamily {
    id!: string;
    husband_id?: string;
    wife_id?: string;
    children?: string[];
}

export class RelationPathResult {
    found!: boolean;
    mode!: 'blood' | 'all';
    steps?: RelationPathStep[];
    /** Tryb krwi: wszystkie kombinacje (steps = paths[0]). */
    paths?: RelationPathStep[][];
    /** Osoby ze ścieżek; żyjące mogą być pominięte (sesja anonimowa). */
    persons?: WebFamTreeView[];
    families?: RelationPathFamily[];
}

export class PersonLookupResult {
    id?: string;
    language?: string;
    person?: WebFamPerson;
/*    searchString?: string;
    events?: GenEvent[];
    children?: PersonSearchResult[];*/
}


/** Osoba obserwowana pod kątem wspólnych przodków - prywatna lista użytkownika. */
export class WatchedPerson {
    person_id!: string;
    textid?: string;
    fullname?: string;
}

/** Obserwowana osoba razem z jej przodkami: id przodka -> numer pokolenia. */
export class WatchedPersonAncestors extends WatchedPerson {
    ancestors!: {[key: string]: number};
}

/** Poziom pokrewieństwa osoby wobec jednej obserwowanej osoby - karta na profilu. */
export class WatchedPersonRelation extends WatchedPerson {
    level!: number;
}
